import { render } from "./CardBudgetInvestment.vue?vue&type=template&id=0e842987&scoped=true"
import script from "./CardBudgetInvestment.vue?vue&type=script&lang=js"
export * from "./CardBudgetInvestment.vue?vue&type=script&lang=js"

import "./CardBudgetInvestment.vue?vue&type=style&index=0&id=0e842987&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e842987"]])

export default __exports__